export function generateId() {
  return Date.now();
}
